export const NEWS_RESET = 'NEWS_RESET';
export const NEWS_SET_FILTERS = 'NEWS_SET_FILTERS';

export const NEWS_FETCH_START = 'NEWS_FETCH_START';
export const NEWS_FETCH_SUCCESS = 'NEWS_FETCH_SUCCESS';
export const NEWS_FETCH_ERROR = 'NEWS_FETCH_ERROR';

export const NEWS_CREATE_SUCCESS = 'NEWS_CREATE_SUCCESS';
export const NEWS_UPDATE_SUCCESS = 'NEWS_UPDATE_SUCCESS';
export const NEWS_DELETE_SUCCESS = 'NEWS_DELETE_SUCCESS';
export const NEWS_DELETE_SOCKET = 'NEWS_DELETE_SOCKET';

export const NEWS_MARK_READ = 'NEWS_MARK_READ';
export const NEWS_TOGGLE_PIN_LOCAL = 'NEWS_TOGGLE_PIN_LOCAL';
